<template>
  <div>
    <el-form :model="searchForm">
      <el-form-item>
        <el-button
          v-if="open"
          type="success"
          @click="Toexpandall"
          >全部展开</el-button
        >
        <el-button
          v-if="close"
          type="danger"
          @click="ToClose"
          >全部收起</el-button
        >
        <el-button
          type="primary"
          @click="addUpdateMenuButton(0)"
          v-if="hasAuth('sys:cate:add')"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%;"
      row-key="id"
      border
      stripe
      ref="tabletree"
      :default-expand-all="false"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="" label="名称" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.firstLevelId
              ? "2级 —" + scope.row.name
              : "1级—" + scope.row.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
      ></el-table-column>
      <el-table-column prop="icon" align="center" label="图标">
        <template slot-scope="scope" v-if="!scope.row.firstLevelId">
          <img class="terico" :src="scope.row.cover" />
        </template>
      </el-table-column>
      <!-- <el-table-column prop="icon" align="center" label="二级选中图标">
				<template slot-scope="scope" >
					<img v-if="scope.row.parentId!=0" class="terico" :src="scope.row.selectIcon" />
				</template>
			</el-table-column> -->

      <!-- <el-table-column prop="" label="是否禁用" align="center">
				<template slot-scope="scope">
					<span v-if="scope.row.state=='true'">启用</span>
					<span class="redname" v-else>禁用</span>
				</template>
			</el-table-column> -->
      <el-table-column label="操作" align="center" width="380">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            @click="updateMenuButton(scope.row)"
            v-if="hasAuth('sys:cate:edit')"
            >编辑</el-button
          >
          <el-popconfirm
            title="确定要删除这个分类吗？"
            @confirm="delHandle(scope.row)"
            v-if="hasAuth('sys:cate:del')"
          >
            <el-button type="danger" slot="reference">删除</el-button>
          </el-popconfirm>
          <!-- <el-button type="primary" v-if="scope.row.state=='false'" plain @click="uncates(scope.row)">启用</el-button>
					<el-popconfirm v-else title="确定要禁用这个分类吗？" @confirm="uncates(scope.row)">
						<el-button type="danger" slot="reference">禁用</el-button>
					</el-popconfirm> -->
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      class="dails"
      title="提示"
      :visible.sync="addUpdateMenuvisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        ref="editForm"
        label-width="100px"
        class="demo-editForm"
      >
        <el-form-item label="上级菜单" prop="parentId" v-if="!this.cateid">
          <el-select v-model="editForm.parentId" placeholder="请选择上级菜单">
            <el-option :value="0" label="--"></el-option>
            <template v-for="item in tableData">
              <el-option :label="item.name" :value="item.id"></el-option>
              <!-- <template v-for="child in item.categoryVos">
								<el-option :label="child.name" :value="child.id">
									<span>{{ "- " + child.name }}</span>
								</el-option>
							</template> -->
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称" prop="name" label-width="100px">
          <el-input v-model="editForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="图标(1:1)"
          prop="avatar"
          label-width="100px"
          v-if="!editForm.parentId"
        >
          <VploadImg
            :limit="1"
            v-bind:file-list="fileList"
            :file-type="1"
            @submitImg="getImgList"
          >
          </VploadImg>
        </el-form-item>
        <div style="height: 30px"></div>
        <el-form-item label="排序号" prop="orderNum" label-width="100px">
          <el-input-number v-model="editForm.orderNum" :min="0" label="排序号"
            >0</el-input-number
          >
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">完成</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import VploadImg from "../inc/VploadImgThree";
export default {
  name: "catetype",
  components: {
    VploadImg,
  },
  data() {
    return {
      open: true,
      close: false,
      searchForm: {
        name: "",
      },
      fileList: [],
      fileListd: [],
      editForm: {
        parentId: 0,
        name: "",
        iconPath: "",
        orderNum: 0,
        content: "",
        selectIcon: "",
      },
      tableData: [],
      addUpdateMenuvisible: false,
      tier: 1,
      cateid: "",
      leveshow: false,
    };
  },
  created() {
    this.getMenuTree();
  },
  methods: {
    submitForm() {
      this.fileList = [];

      if (this.cateid) {
        this.$axios
          .post("/admin/commodityClassify/upd", {
            id: this.editForm.content,
            cover: this.editForm.iconPath,
            name: this.editForm.name,
            sort: this.editForm.orderNum,
            type: this.editForm.parentId ? 2 : 1,
          })
          .then((res) => {
            if (res.code == 0) {
              (this.editForm = {
                parentId: 0,
                name: "", 
                iconPath: "",
                orderNum: 0,
                content: "",
                selectIcon: "",
              }),
                (this.addUpdateMenuvisible = false);
              this.getMenuTree();
              this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
                onClose: () => {},
              });
            }
          });
      } else {
        if (!this.editForm.parentId) {
          this.$axios
            .post("/admin/commodityClassify/addFirstLevel", {
              cover: this.editForm.iconPath,
              name: this.editForm.name,
              sort: this.editForm.orderNum,
            })
            .then((res) => {
              if (res.code == 0) {
                (this.editForm = {
                  parentId: 0,
                  name: "",
                  iconPath: "",
                  orderNum: 0,
                  content: "",
                  selectIcon: "",
                }),
                  (this.addUpdateMenuvisible = false);
                this.getMenuTree();
                this.$message({
                  showClose: true,
                  message: "恭喜你，操作成功",
                  type: "success",
                  onClose: () => {},
                });
              }
            });
        } else {
          this.$axios
            .post("/admin/commodityClassify/add", {
              firstLevelId: this.editForm.parentId,
              name: this.editForm.name,
              sort: this.editForm.orderNum,
            })
            .then((res) => {
              if (res.code == 0) {
                (this.editForm = {
                  parentId: 0,
                  name: "",
                  iconPath: "",
                  orderNum: 0,
                  content: "",
                  selectIcon: "",
                }),
                  (this.addUpdateMenuvisible = false);
                this.getMenuTree();
                this.$message({
                  showClose: true,
                  message: "恭喜你，操作成功",
                  type: "success",
                  onClose: () => {},
                });
              }
            });
        }
      }
    },

    uncates(e) {
      var flag = "";
      if (e.state == "true") {
        flag = "false";
      } else {
        flag = "true";
      }
      this.$axios
        .post("/admin/category/modifyState", {
          id: e.id,
          flag: flag,
        })
        .then((res) => {
          if (res.code == 0) {
            this.getMenuTree();
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
          }
        });
    },
    updateMenuButton(e) {
      var that = this;
      that.cateid = e.id;
      var filess = {
        url: e.cover,
      };

      this.fileList.push(filess);
      this.editForm.name = e.name;
      this.editForm.orderNum = e.sort;

      if (e.firstLevelId) {
        this.editForm.parentId = e.firstLevelId;
        this.editForm.content = e.uid;
        this.leveshow = true;
      } else {
        this.editForm.parentId = 0;
        this.editForm.content = e.id;
        this.leveshow = false;
      }
      setTimeout(function () {
        that.addUpdateMenuvisible = true;
      }, 100);
    },
    getImgList(url) {
      //  url
      this.editForm.iconPath = url;
    },
    getList(url) {
      //  url
      this.editForm.selectIcon = url;
    },
    getMenuTree() {
      this.$axios
        .get("/admin/commodityClassify/getAllLevelList")
        .then((res) => {
          res.data.map((item) => {
            if (item.children) {
              item.children.map((items) => {
                items.id = items.id + "two";
              });
            }
          });
          this.tableData = res.data;
        });
    },

    delHandle(id) {
      this.$axios
        .post("/admin/commodityClassify/delete", {
          id: id.uid || id.id,
          type: id.uid ? "2" : 1,
        })
        .then((res) => {
          this.getMenuTree();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
    },
    handleClose() {
      this.fileList = [];
      this.fileListd = [];
      this.addUpdateMenuvisible = false;
    },
    addUpdateMenuButton() {
      this.cateid = "";
      this.editForm = {
        parentId: 0,
        name: "",
        iconPath: "",
        orderNum: 0,
        content: "",
        selectIcon: "",
      };
      this.addUpdateMenuvisible = true;
    },
    // 全部展开
    Toexpandall() {
      let els = document.getElementsByClassName("el-table__expand-icon");
      if (this.tableData.length != 0 && els.length != 0) {
        this.open = false;
        this.close = true;
        for (let j1 = 0; j1 < els.length; j1++) {
          els[j1].classList.add("dafult");
        }
        if (
          this.$el.getElementsByClassName("el-table__expand-icon--expanded")
        ) {
          const open = this.$el.getElementsByClassName(
            "el-table__expand-icon--expanded"
          );
          for (let j = 0; j < open.length; j++) {
            open[j].classList.remove("dafult");
            // open[j].classList.remove("el-table__expand-icon--expanded")
            // open[j].click(function(event) {
            //   event.preventDefault();
            // })
          }
          const dafult = this.$el.getElementsByClassName("dafult");
          for (let a = 0; a < dafult.length; a++) {
            dafult[a].click();
          }
        }
      }
    },
    // 全部收起
    ToClose() {
      if (this.tableData.length != 0) {
        this.open = true;
        this.close = false;
        const elsopen = this.$el.getElementsByClassName(
          "el-table__expand-icon--expanded"
        );
        if (
          this.$el.getElementsByClassName("el-table__expand-icon--expanded")
        ) {
          for (let i = 0; i < elsopen.length; i++) {
            elsopen[i].click();
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  margin-right: 10px;
}

.terico {
  width: 50px;
  height: 50px;
}

.redname {
  color: #cd0000;
}
</style>
